import React from 'react';
import styled from 'styled-components';
import { VehicleModelProps } from './car-model';
import { VehicleSide } from '../../enums';
import VehicleStateImg from './vehicle-state-img';
import FrontFenderImg from '../../assets/images/car-model/front_fender.png';

interface Props extends VehicleModelProps {
  side: VehicleSide;
}

const FRONT_FENDER_STYLES = {
  [VehicleSide.Left]: 0,
  [VehicleSide.Right]: 180,
};

class VehicleFrontFender extends React.Component<Props, any> {
  getVehicleItem = () => `${this.props.side}-front-fender`;

  clickHandler = () => {
    const { clickHandler } = this.props;
    clickHandler && clickHandler(this.getVehicleItem());
  };

  render() {
    const { className, vehicleState } = this.props;
    const vehicleItem = this.getVehicleItem();

    return (
      <VehicleStateImg
        className={`${className} ${vehicleState[vehicleItem]}`}
        src={FrontFenderImg}
        onClick={this.clickHandler}
      />
    );
  }
}

const StyledVehicleFrontFender = styled(VehicleFrontFender)`
  position: relative;
  width: 3.5em;
  margin-bottom: 1.5em;
  transform: rotateY(${({ side }) => FRONT_FENDER_STYLES[side]}deg);
`;

export default StyledVehicleFrontFender;
